export default {
    name: "customer-sign-up",
    data() {
        return {
            timenow: new Date(),
            showNameAndMobileNumberForm: true,
            showOtpForm: false,
            showCustomerDetailsForm: false,
            showSignUpSuccess: false,
            instanceId: null,
            instanceIdStorage: {}
        };
    },
    methods: {
        continueToNextStep(eventResponse){
            if(eventResponse.canContinue && this.showNameAndMobileNumberForm){
                this.showNameAndMobileNumberForm = false;
                this.showOtpForm = true;
                this.instanceId = eventResponse.instanceId;
                localStorageCacheHelper.setOtpFormCache(this.instanceId, "instanceId", false);
                //this.$router.push("/customer-sign-up/enter-verification-code");
            }
            else if(eventResponse.canContinue && this.showOtpForm){
                this.showNameAndMobileNumberForm = false;
                this.showOtpForm = false;
                this.showCustomerDetailsForm = true;
                localStorageCacheHelper.setOtpFormCache(this.instanceId, "instanceId", true);
                //this.$router.push("/customer-sign-up/enter-verification-code");
            }
            else if(eventResponse.canContinue && this.showCustomerDetailsForm){
                this.showSignUpSuccess = true;
                this.showCustomerDetailsForm = false;
            }
        },
    },
    mounted: function () {
        this.instanceIdStorage = localStorageCacheHelper.getOtpFormCache("instanceId");
        if(this.instanceIdStorage !== null){
            if(this.instanceIdStorage.instanceId !== null){
                this.instanceId = this.instanceIdStorage.instanceId;
                if(this.instanceIdStorage.otpDone){
                    this.showNameAndMobileNumberForm = false;
                    this.showOtpForm = false;
                    this.showCustomerDetailsForm = true;
                }
                else{
                    this.showNameAndMobileNumberForm = false;
                    this.showOtpForm = true;
                }
            }
        }
    }
};